<template>
  <div v-if="gridInverter !== null" class="modal-inverters-table-wrapp">
    <div class="overlay-modal-inverters-table"></div>
    <div class="modal-inverters-table">
      <div @click="close" class="close-modal-inverters-table"></div>
      <div class="square-table">
        <div class="square-table__name">{{gridInverter.name}}</div>
        <div class="square-tb-row">
          <div class="square-tb-col width-60">
            <div class="square-tb-bg">
              <table class="square-tb">
                <tr>
                  <th></th>
                  <th>A</th>
                  <th>B</th>
                  <th>C</th>
                </tr>
                <tr>
                  <td><span class="title">Grid Voltage (V):</span></td>
                  <td>{{gridInverter.data['Phase_A_voltage']}}</td>
                  <td>{{gridInverter.data['Phase_B_voltage']}}</td>
                  <td>{{gridInverter.data['Phase_C_voltage']}}</td>
                </tr>
                <tr>
                  <td><span class="title">Grid Currnet (A):</span></td>
                  <td>{{gridInverter.data['Phase_A_current']}}</td>
                  <td>{{gridInverter.data['Phase_B_current']}}</td>
                  <td>{{gridInverter.data['Phase_C_current']}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="square-tb-col width-40">
            <div class="square-tb-bg">
              <table class="square-tb">
                <tr>
                  <td><span class="title">Active Power (Kw):</span></td>
                  <td>{{gridInverter.data['Active_power']}}</td>
                </tr>
                <tr>
                  <td><span class="title">Reactive Power (Kw):</span></td>
                  <td>{{gridInverter.data['Reactive_power']}}</td>
                </tr>
                <tr>
                  <td><span class="title">Input power (Kw):</span></td>
                  <td>{{gridInverter.data['Input_power']}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="square-tb-col width-100">
            <vue-custom-scrollbar  class="" :settings="{}">
              <div class="square-tb-bg">
                <table class="square-tb">
                  <tr>
                    <th></th>
                    <th>pv1</th>
                    <th>pv2</th>
                    <th>pv3</th>
                    <th>pv4</th>
                    <th>pv5</th>
                    <th>pv6</th>
                  </tr>
                  <tr>
                    <td><span class="title">Input Voltage (V):</span></td>
                    <td>{{gridInverter.data['PV1_voltage']}}</td>
                    <td>{{gridInverter.data['PV2_voltage']}}</td>
                    <td>{{gridInverter.data['PV3_voltage']}}</td>
                    <td>{{gridInverter.data['PV4_voltage']}}</td>
                    <td>{{gridInverter.data['PV5_voltage']}}</td>
                    <td>{{gridInverter.data['PV6_voltage']}}</td>
                  </tr>
                  <tr>
                    <td><span class="title">Input Currnet (A):</span></td>
                    <td>{{gridInverter.data['PV1_current']}}</td>
                    <td>{{gridInverter.data['PV2_current']}}</td>
                    <td>{{gridInverter.data['PV3_current']}}</td>
                    <td>{{gridInverter.data['PV4_current']}}</td>
                    <td>{{gridInverter.data['PV5_current']}}</td>
                    <td>{{gridInverter.data['PV6_current']}}</td>
                  </tr>
                </table>
              </div>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import '../../../assets/css/custom-scrollbar.scss'

export default {
  name: 'InverterModal',
  components: {
    vueCustomScrollbar
  },
  methods: {
    close () {
      this.$store.commit('stations/UNSET_INVERTER')
    }
  },
  computed: {
    gridInverter () {
      return this.$store.getters['stations/inverter']
    }
  }
}
</script>
